exports.APPLIED_LIBRARY_ID = 1
exports.MAX_JOB_FUNCTIONS = 3